(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rd-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
    // Ajoute N jours ouvrés (hors samedi et dimanche) à une date
    function addBusinessDays(date, days) {
      var d = new Date(date.getTime());
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) added++;
      }
      return d;
    }

    function fill() {
      var lang = document.documentElement.lang || 'fr';
      document.querySelectorAll('[data-rd-eta]').forEach(function (root) {
        var out = root.querySelector('[data-rd-eta-range]');
        if (!out) return;
        var min = parseInt(root.getAttribute('data-min'), 10);
        var max = parseInt(root.getAttribute('data-max'), 10);
        if (!min || !max) return;
        try {
          var now = new Date();
          var fmt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long' });
          var text = fmt.formatRange(addBusinessDays(now, min), addBusinessDays(now, max));
          // on n'écrit que si le texte diffère, pour ne pas relancer l'observateur en boucle
          if (out.textContent !== text) out.textContent = text;
        } catch (e) { /* le texte "10–20 jours ouvrés" du serveur reste affiché */ }
      });
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; fill(); });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill);
    else fill();

    // Horizon remplace des morceaux de la page quand on change de variante : on réécrit les dates si besoin
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    document.addEventListener('shopify:section:load', fill);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rd-variant-images"] && !Shopify.designMode) return;
  try {
    (function () {
    function readMap() {
      var script = document.querySelector('script[data-rd-variant-images]');
      if (!script) return null;
      try { return JSON.parse(script.textContent); } catch (e) { return null; }
    }

    function enhance() {
      var map = readMap();
      if (!map) return;

      document.querySelectorAll('.product-details fieldset').forEach(function (fieldset) {
        var inputs = fieldset.querySelectorAll('input[type="radio"][data-option-value-id]');
        if (inputs.length < 2) return;

        // On n'ajoute des images que si chaque valeur a SA propre image (une couleur, oui ; une taille, non)
        var urls = [];
        inputs.forEach(function (input) { urls.push(map[input.getAttribute('data-option-value-id')] || ''); });
        var distinct = urls.filter(function (u, i) { return u && urls.indexOf(u) === i; }).length;
        if (distinct !== inputs.length) return;

        inputs.forEach(function (input, i) {
          var label = input.closest('label');
          if (!label || label.querySelector('.rd-vimg')) return;
          var span = document.createElement('span');
          span.className = 'rd-vimg';
          var img = document.createElement('img');
          img.src = urls[i];
          img.alt = '';
          img.loading = 'lazy';
          span.appendChild(img);
          label.appendChild(span);
          label.classList.add('rd-has-vimg');
        });

        // Nom de la couleur sélectionnée à côté du titre de l'option
        var legend = fieldset.querySelector('legend');
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        if (legend && checked) {
          var sel = legend.querySelector('.rd-vsel');
          if (!sel) {
            sel = document.createElement('span');
            sel.className = 'rd-vsel';
            legend.appendChild(sel);
          }
          if (sel.textContent !== checked.value) sel.textContent = checked.value;
        }
      });
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; enhance(); });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
    else enhance();

    // Horizon remplace des morceaux de la page à chaque changement de variante : on réapplique
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('change', schedule);
    document.addEventListener('shopify:section:load', enhance);
  })();
  } catch(e) { console.error(e); }
})();

})();
